document.addEventListener("DOMContentLoaded", function () {
  const sectionId = "{{ section.id }}";
  const section = document.querySelector(`[data-section-id="${sectionId}"]`);

  if (!section) return;

  const stepsContainer = section.querySelector("[data-steps-container]");
  const steps = section.querySelectorAll(".scroll-steps__step");

  if (!stepsContainer || steps.length === 0) return;

  let isScrolling = false;
  let currentActiveStep = 0;
  let sectionSticky = false;
  let allowPageScroll = false;

  // Function to update active step based on scroll position
  function updateActiveStep() {
    const containerRect = stepsContainer.getBoundingClientRect();
    const activeZoneTop = 0; // Top of the active zone
    const activeZoneBottom = 70; // 70px from top as requested

    let newActiveStep = -1;

    steps.forEach((step, index) => {
      const stepRect = step.getBoundingClientRect();
      const stepTop = stepRect.top - containerRect.top;
      const stepBottom = stepTop + stepRect.height;

      // Check if step is in the active zone (top 70px)
      if (stepTop <= activeZoneBottom && stepBottom >= activeZoneTop) {
        newActiveStep = index;
      }
    });

    // Update active class if changed
    if (newActiveStep !== currentActiveStep && newActiveStep !== -1) {
      steps.forEach((step) =>
        step.classList.remove("scroll-steps__step--active")
      );

      if (steps[newActiveStep]) {
        steps[newActiveStep].classList.add("scroll-steps__step--active");
      }

      currentActiveStep = newActiveStep;
    }
  }

  // Function to handle sticky behavior
  function handleStickyScroll() {
    const sectionRect = section.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    // Check if section should be sticky (reached top of viewport)
    if (sectionRect.top <= 0 && !sectionSticky) {
      sectionSticky = true;
      section.classList.add("scroll-steps--sticky");
      allowPageScroll = false;
    }

    // Check if we should allow page scroll again
    if (sectionSticky && !allowPageScroll) {
      const stepsScrollTop = stepsContainer.scrollTop;
      const stepsScrollHeight = stepsContainer.scrollHeight;
      const stepsClientHeight = stepsContainer.clientHeight;

      // If scrolled to bottom of steps container
      if (stepsScrollTop + stepsClientHeight >= stepsScrollHeight - 1) {
        allowPageScroll = true;
      }
    }

    // Reset sticky state if scrolled back up
    if (sectionRect.top > 0 && sectionSticky) {
      sectionSticky = false;
      allowPageScroll = false;
      section.classList.remove("scroll-steps--sticky");
    }
  }

  // Prevent page scroll when section is sticky and steps haven't finished scrolling
  function preventPageScroll(e) {
    if (sectionSticky && !allowPageScroll) {
      const stepsScrollTop = stepsContainer.scrollTop;
      const stepsScrollHeight = stepsContainer.scrollHeight;
      const stepsClientHeight = stepsContainer.clientHeight;

      // Prevent page scroll and scroll the steps container instead
      if (e.deltaY > 0) {
        // Scrolling down
        if (stepsScrollTop + stepsClientHeight < stepsScrollHeight) {
          e.preventDefault();
          stepsContainer.scrollTop += e.deltaY;
        }
      } else {
        // Scrolling up
        if (stepsScrollTop > 0) {
          e.preventDefault();
          stepsContainer.scrollTop += e.deltaY;
          allowPageScroll = false; // Reset page scroll permission
        }
      }
    }
  }

  // Throttled scroll handlers
  function throttledScrollHandler() {
    if (!isScrolling) {
      requestAnimationFrame(() => {
        updateActiveStep();
        handleStickyScroll();
      });
      isScrolling = true;
      setTimeout(() => {
        isScrolling = false;
      }, 16);
    }
  }

  function throttledStepsScrollHandler() {
    if (!isScrolling) {
      requestAnimationFrame(updateActiveStep);
      isScrolling = true;
      setTimeout(() => {
        isScrolling = false;
      }, 16);
    }
  }

  function init() {
    // Initialize active step
    updateActiveStep();

    // Add event listeners
    window.addEventListener("scroll", throttledScrollHandler);
    window.addEventListener("wheel", preventPageScroll, { passive: false });
    stepsContainer.addEventListener("scroll", throttledStepsScrollHandler);

    // Set initial active step
    if (steps.length > 0) {
      steps[0].classList.add("scroll-steps__step--active");
      currentActiveStep = 0;
    }
  }

  function cleanup() {
    window.removeEventListener("scroll", throttledScrollHandler);
    window.removeEventListener("wheel", preventPageScroll);
    stepsContainer.removeEventListener("scroll", throttledStepsScrollHandler);
  }

  init();

  // Store cleanup function globally for section unload
  window.sectionCleanup = window.sectionCleanup || {};
  window.sectionCleanup[sectionId] = cleanup;
});

// Handle section unload (Shopify theme editor)
document.addEventListener("shopify:section:unload", function (event) {
  const sectionId = event.target.getAttribute("data-section-id");
  if (window.sectionCleanup && window.sectionCleanup[sectionId]) {
    window.sectionCleanup[sectionId]();
    delete window.sectionCleanup[sectionId];
  }
});
